import ExpensesData from "./data";

export default function expensesDataFromJson(json) {
    return new ExpensesData(
        json.fuelLowSulfur,
        json.fuelOil,
        json.time
    )
}